/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './EnergiaSolarHeroMesAmbiente.css';
import RedButton from '@/components/atoms/RedButton';

function EnergiaSolarHeroMesAmbiente() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="hero-santander-financiamentos">
        <div className="bg-hero">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 450 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/energia-solar/banner-320.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/energia-solar/banner-320.png"
                    alt="Banner sobre energia solar com residência equipada com placas fotovoltaicas. Campanha do Mês do Meio Ambiente promove soluções sustentáveis e economia de longo prazo com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 450 && width <= 799 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/energia-solar/banner-450.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/energia-solar/banner-450.png"
                    alt="Banner sobre energia solar com residência equipada com placas fotovoltaicas. Campanha do Mês do Meio Ambiente promove soluções sustentáveis e economia de longo prazo com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 799 && width <= 993 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/energia-solar/banner-800.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/energia-solar/banner-800.png"
                    alt="Banner sobre energia solar com residência equipada com placas fotovoltaicas. Campanha do Mês do Meio Ambiente promove soluções sustentáveis e economia de longo prazo com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 993 && width <= 1280 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/energia-solar/banner-992.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/energia-solar/banner-992.png"
                    alt="Banner sobre energia solar com residência equipada com placas fotovoltaicas. Campanha do Mês do Meio Ambiente promove soluções sustentáveis e economia de longo prazo com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 1280 && width <= 1360 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/energia-solar/banner-1280.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/energia-solar/banner-1280.png"
                    alt="Banner sobre energia solar com residência equipada com placas fotovoltaicas. Campanha do Mês do Meio Ambiente promove soluções sustentáveis e economia de longo prazo com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 1360 && width <= 1920 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/energia-solar/banner-1360.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/energia-solar/banner-1360.png"
                    alt="Banner sobre energia solar com residência equipada com placas fotovoltaicas. Campanha do Mês do Meio Ambiente promove soluções sustentáveis e economia de longo prazo com o Santander."
                    className=""
                  />
                </picture>
              )}
              {/* {width > 1360 && width <= 1440 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/energia-solar/banner-1440.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/energia-solar/banner-1440.png"
                    alt="Banner sobre energia solar com residência equipada com placas fotovoltaicas. Campanha do Mês do Meio Ambiente promove soluções sustentáveis e economia de longo prazo com o Santander."
                    className=""
                  />
                </picture>
              )} */}
              {width > 1920 && width <= 2650 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/energia-solar/banner-1920.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/energia-solar/banner-1920.png"
                    alt="Banner sobre energia solar com residência equipada com placas fotovoltaicas. Campanha do Mês do Meio Ambiente promove soluções sustentáveis e economia de longo prazo com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 2650 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/energia-solar/banner-2650.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/energia-solar/banner-2650.png"
                    alt="Banner sobre energia solar com residência equipada com placas fotovoltaicas. Campanha do Mês do Meio Ambiente promove soluções sustentáveis e economia de longo prazo com o Santander."
                    className=""
                  />
                </picture>
              )}
            </>
          )}
        </div>
        <ContainerHome24>
          <div className="hero-contain">
            <div className="hero-buttons">
              <RedButton href="#energia-solar-parceiros">Encontrar parceiros</RedButton>
              {/* <RedButton href="#santander-carousel" id="hero-button-outros-produtos">
                Produtos
              </RedButton> */}
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default EnergiaSolarHeroMesAmbiente;
